import { useQuery } from '@apollo/client';
import createShopifyClient from '../clients/createShopifyClient';
import GET_ALL_ORDERS from '../../commons/gql/remote/GetAllOrders';

const client = createShopifyClient();

const useOrders = () => useQuery(GET_ALL_ORDERS, { client });

export default useOrders;
